// utils/chartOptions.js
export const buildDynamicPieOptions = (labels, customColors) => {
  const palette = customColors?.length ? customColors : ["#4318FF", "#6AD2FF", "#EFF4FB"];

  return {
    labels,
    colors: palette,
    chart: {
      // keep toolbar hidden for clean card look
      toolbar: { show: false },
      // smooth transitions when series/labels change
      animations: {
        enabled: true,
        easing: "easeinout",
        speed: 700,
        animateGradually: { enabled: true, delay: 120 },
        dynamicAnimation: { enabled: true, speed: 550 },
      },
      // width can be controlled by container; keep this if you want the same feel
      width: "50px",
    },
    states: {
      hover: {
        filter: { type: "none" }, // same as your static
      },
      active: {
        filter: { type: "none" },
      },
    },
    legend: { show: false },
    dataLabels: { enabled: false },
    hover: { mode: null },
    plotOptions: {
      // works for both type: "pie" and "donut"
      pie: {
        expandOnClick: false,
        donut: {
          size: "70%", // visually match your UI; tweak as needed
          labels: {
            show: false, // matches your static
          },
        },
      },
    },
    fill: {
      colors: palette,
      // keep solid fill to match your static pie; if you want gradient, add it here
    },
    tooltip: {
      enabled: true,
      theme: "dark",
      style: {
        fontSize: "12px",
        fontFamily: undefined,
        backgroundColor: "#000000",
      },
      y: {
        formatter: (v) =>
          `${(v ?? 0)?.toLocaleString?.("en-IN") ?? v} bookings`,
      },
    },
    // Disable stroke or keep minimal to mimic your static look
    stroke: {
      show: false,
      width: 0,
    },
  };
};